import React from 'react'
import { SvgIconProps } from './Home'

const SvgShareFeedbackIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    fill="none"
    viewBox="0 0 19 19"
  >
    <path
      fill={fill ?? "#353535"}
      d="M8.287 12.532c-.303.303-.505.707-.505 1.112 0 .404.202.808.505 1.111.303.304.607.405 1.112.405.505 0 .809-.203 1.112-.506.303-.303.505-.707.505-1.111 0-.405-.202-.809-.505-1.112-.607-.505-1.617-.505-2.224.101z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M12.128 4.548a16.444 16.444 0 00-1.314-.607c-.91-.202-1.92-.202-2.83.101-.404.203-.808.405-1.112.607-.404.303-.606.606-.808 1.01a1.942 1.942 0 00-.404 1.213c0 .506.202.809.404 1.01.505.405 1.314.405 1.718.102.202-.202.303-.303.404-.505.101-.202.202-.304.303-.506.101-.1.101-.202.202-.303.102-.1.203-.202.304-.202.1 0 .202-.101.505-.101s.606.101.707.202c.101.101.202.202.202.606 0 .203 0 .304-.1.405l-.304.303c-.202.202-.404.303-.606.505-.202.202-.404.303-.606.506-.203.202-.405.505-.607.707-.1.303-.202.606-.202.91 0 .303.101.606.303.91.202.201.506.505 1.01.505.304 0 .607-.102.708-.203.202-.1.303-.303.404-.404.102-.101.102-.303.203-.505 0-.101.1-.202.1-.303l.203-.203.505-.404c.202-.1.404-.303.607-.505l.606-.607c.404-.202.505-.404.606-.707.101-.303.202-.606.202-1.01 0-.607-.1-1.112-.404-1.517-.202-.404-.505-.707-.91-1.01z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M9.5 0A9.489 9.489 0 000 9.5C0 14.755 4.245 19 9.5 19S19 14.755 19 9.5 14.755 0 9.5 0zm7.277 9.5c0 3.941-3.234 7.277-7.277 7.277A7.246 7.246 0 012.223 9.5 7.246 7.246 0 019.5 2.223c4.043 0 7.277 3.336 7.277 7.277z"
    ></path>
  </svg>
)

export default SvgShareFeedbackIcon